import React from "react";
import { Wrench } from "lucide-react";
import ComingSoonFormat from "@/components/site/ComingSoonFormat";

export default function Use() {
  return (
    <ComingSoonFormat
      testId="use-page"
      label="Use"
      Icon={Wrench}
      headline="Tools you can actually use."
      description="Templates, checklists, and frameworks pulled directly from the interviews. Not generic business tools. Working documents from operators who use them."
      bullets={[
        "Hiring rubrics and interview scorecards.",
        "Cash flow and pricing templates.",
        "Delegation frameworks and first-manager playbooks.",
        "Post-mortem and decision-review checklists.",
      ]}
    />
  );
}
